/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import logo from "/anchorsBetaLogo.png";
import { PiArrowsLeftRight, PiSquaresFourBold } from "react-icons/pi";
import { useAuth } from "../../../Providers/Auth";
import { useLocation, useNavigate } from "react-router-dom";
import { Textarea } from "@/shadcnComponents/ui/textarea";
import { useToast } from "@/shadcnComponents/ui/use-toast";
import axios from "axios";

import { useBrand } from "../../../Providers/Brand";
import mixpanel from "mixpanel-browser";
import { Button } from "@/shadcnComponents/ui/button";
import {
  ArrowRight,
  ChevronsUpDown,
  LayoutDashboard,
  LoaderCircle,
  Plus,
  PlusCircle,
} from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/shadcnComponents/ui/popover";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shadcnComponents/ui/dialog";
import { Input } from "@/shadcnComponents/ui/input";
import { Label } from "@/shadcnComponents/ui/label";
import { useGeneralSettings } from "@/Providers/General";
import { getRandomProfileEmoji } from "@/Helpers/helper";
import {
  campaignTypes,
  initialNewCampaignFormData,
} from "@/Pages/Brand/DashBoard/PromoteAd/Helpers/Helper";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/shadcnComponents/ui/select";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/shadcnComponents/ui/tooltip";
import { cn } from "@/lib/utils";
const host = import.meta.env.VITE_BACKEND_SERVER_URL;

export const UnlockProfileSvg = ({ fill }) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 20 19"
        fill="none"
      >
        <path
          d="M8 8C10.21 8 12 6.21 12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8ZM8 2C8.53043 2 9.03914 2.21071 9.41421 2.58579C9.78929 2.96086 10 3.46957 10 4C10 4.53043 9.78929 5.03914 9.41421 5.41421C9.03914 5.78929 8.53043 6 8 6C6.89 6 6 5.11 6 4C6 2.89 6.9 2 8 2ZM10 16H0V13C0 10.33 5.33 9 8 9C8.91 9 10.13 9.16 11.35 9.47C11.26 9.8 11.2 10.15 11.2 10.5V11.39C10.22 11.1 9.1 10.9 8 10.9C5.03 10.9 1.9 12.36 1.9 13V14.1H10V14.2V16ZM18.8 13H14.5V10.5C14.5 9.7 15.2 9.2 16 9.2C16.8 9.2 17.5 9.7 17.5 10.5V11H18.8V10.5C18.8 9.1 17.4 8 16 8C14.6 8 13.2 9.1 13.2 10.5V13C12.6 13 12 13.6 12 14.2V17.7C12 18.4 12.6 19 13.2 19H18.7C19.4 19 20 18.4 20 17.8V14.3C20 13.6 19.4 13 18.8 13Z"
          fill={fill || "#424242"}
        />
      </svg>
    </>
  );
};

interface CreateNewCampaignProps {
  open?: boolean;
  handleOnOpenChange?: (isOpen: boolean) => void;
  showTrigger?: boolean;
  className?: string;
  size?: "default" | "sm" | "lg" | "icon";
  text?: string;
}

export const CreateNewCampaign = ({
  open,
  handleOnOpenChange,
  showTrigger = true,
  className,
  size = "sm",
  text,
}: CreateNewCampaignProps) => {
  const navigate = useNavigate();
  const generalState = useGeneralSettings();
  const { toast } = useToast();
  const authState = useAuth();
  const [creatingNew, setCreatingNew] = useState(false);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    collabType: "performance",
  });

  const handleKeyDown = React.useCallback(
    (e: React.KeyboardEvent<HTMLDivElement>) => {
      if (e.key === "Enter") {
        setCreatingNew(true);
        handleSubmit();
      }
    },
    [formData]
  );

  const handleSubmit = async () => {
    if (formData.title === "") {
      toast({
        description: "Title is required",
        variant: "destructive",
      });
      return;
    } else {
      setCreatingNew(true);
      handleCreateNewCampaign();
    }
  };

  const handleCreateNewCampaign = async () => {
    if (
      localStorage.getItem("jwtToken") &&
      localStorage.getItem("UserType").toLocaleLowerCase() === "brand"
    ) {
      try {
        generalState?.setLoading(true);
        const res = await axios.post(
          `${host}/collabs/brand/createBrandCollabs`,
          {
            step: 0,
            data: {
              ...initialNewCampaignFormData,
              campaignInfo: {
                ...initialNewCampaignFormData.campaignInfo,
                campaignName: formData.title,
                campaignDescription: formData.description,
                collabType: formData.collabType,
              },
            },
          },
          {
            headers: {
              jwtToken: localStorage.getItem("jwtToken"),
            },
          }
        );

        if (res?.status === 200 && res?.data?.success) {
          setCreatingNew(false);
          generalState?.setLoading(false);
          navigate(
            `/Brand/DashBoard/AllCampaign/Draft/${res?.data?.collab?._id}`
          );
        }
      } catch (error) {
        setCreatingNew(false);
        generalState?.setLoading(false);
        console.log(error);
      }
    }
  };
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <>
      <Dialog open={open} onOpenChange={handleOnOpenChange}>
        {showTrigger && (
          <DialogTrigger asChild>
            <Button
              onClick={() =>
                mixpanel.track("Brand Sidebar: Create Campaign - clicked")
              }
              size={size ?? "sm"}
              disabled={authState?.loggedBrand?.isSampleBrand}
              variant="destructive"
              className={cn(
                "transition w-full justify-start group-data-[collapsible=icon] ease-in-out delay-150 hover:-translate-y-1 hover:scale-110 duration-300",
                className
              )}
            >
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <PlusCircle className="group-data-[collapsible=icon]:-ml-2 h-4 w-4" />
                  </TooltipTrigger>
                  <TooltipContent className="z-30" side="right" align="center">
                    Create Campaign
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>

              <span className="group-data-[collapsible=icon]:hidden">
                {text ?? "Create Campaign"}
              </span>
            </Button>
          </DialogTrigger>
        )}
        <DialogContent
          onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) =>
            handleKeyDown(e)
          }
          style={{ scrollbarWidth: "thin" }}
          className="sm:max-w-[425px] max-h-[600px] overflow-auto "
        >
          <DialogHeader>
            <DialogTitle>Create New Campaign</DialogTitle>
            <DialogDescription>
              Let's get started by entering a few details
            </DialogDescription>
          </DialogHeader>
          <div className="grid gap-4 py-4">
            <div className="flex flex-col gap-4">
              <div className="w-full space-y-2">
                <Label htmlFor="title" className="text-left">
                  Campaign Name*
                </Label>
                <p className=" text-[color:var(--Natural-800,#424242)] text-xs not-italic font-normal leading-5 ">
                  {
                    "For your reference when managing multiple campaigns. You can edit this later."
                  }
                </p>
                <Input
                  id="title"
                  name="title"
                  placeholder="Product Promotion"
                  className="col-span-3"
                  value={formData?.title}
                  onChange={handleInputChange}
                  required
                  disabled={creatingNew}
                />
              </div>
              <div className="w-full space-y-2">
                <Label htmlFor="description" className="text-left">
                  Description
                </Label>
                <p className=" text-[color:var(--Natural-800,#424242)] text-xs not-italic font-normal leading-5 ">
                  {
                    "Add a brief note about the campaign’s purpose. This is for your reference only."
                  }
                </p>
                <Textarea
                  id="description"
                  name="description"
                  value={formData?.description}
                  onChange={handleInputChange}
                  disabled={creatingNew}
                />
              </div>
              {authState?.loggedBrand?.FixedAvailability && (
                <div className="w-full space-y-2">
                  <Label htmlFor="description" className="text-left">
                    Campaign Type*
                  </Label>
                  <p className=" text-[color:var(--Natural-800,#424242)] text-xs not-italic font-normal leading-5 ">
                    {"Select the mode of campaign you want to execute"}
                  </p>
                  <Select
                    defaultValue={formData?.collabType}
                    onValueChange={(value) =>
                      setFormData((prev) => {
                        return { ...prev, collabType: value };
                      })
                    }
                  >
                    <SelectTrigger>
                      <SelectValue placeholder="Select campaign mode" />
                    </SelectTrigger>
                    <SelectContent className="max-w-sm">
                      <SelectGroup>
                        <SelectLabel>Campaign Type</SelectLabel>
                        {campaignTypes.map((type) => (
                          <SelectItem key={type.value} value={type.value}>
                            {type.label}
                            <span className="block text-sm text-muted-foreground">
                              {type.description}
                            </span>
                          </SelectItem>
                        ))}
                      </SelectGroup>
                    </SelectContent>
                  </Select>
                </div>
              )}
            </div>
          </div>
          <DialogFooter>
            <Button
              variant="destructive"
              disabled={creatingNew}
              type="submit"
              onClick={() => handleSubmit()}
            >
              {creatingNew ? (
                <LoaderCircle className="animate-spin" />
              ) : (
                <>
                  Create <ArrowRight />
                </>
              )}
            </Button>
            {/* <DialogClose asChild>

            </DialogClose> */}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const brandState = useBrand();
  const authState = useAuth();

  const [brand, SetBrand] = useState<any>();
  const [currentProfile, setCurrentProfile] = useState<string>();

  useEffect(() => {
    async function getBrand() {
      const brand = await brandState?.getBrandInfo();
      SetBrand(brand);
    }
    getBrand();

    // Check if profile picture is already stored in session storage
    const storedProfile = sessionStorage.getItem("profilePicture");
    if (!storedProfile) {
      const newProfile = getRandomProfileEmoji();
      sessionStorage.setItem("profilePicture", newProfile);
    }
  }, []);
  useEffect(() => {
    setCurrentProfile(sessionStorage.getItem("profilePicture"));
  }, [sessionStorage.getItem("profilePicture")]);

  return (
    <aside
      className="flex flex-col w-full p-5 box-border gap-5 font-inter h-full z-10 border-r"
      style={{
        width: "260px",
        boxShadow: "rgba(33, 33, 33, 0.08) 4px 0px 8px 0px",
      }}
    >
      <img
        src={logo}
        alt=""
        className="w-32 mb-5 cursor-pointer"
        onClick={() => {
          navigate("/Brand");
        }}
      />
      <CreateNewCampaign />

      {/* ---------------------- navigation section ------------- */}
      <section
        className="flex-1 overflow-x-scroll mt-[40px]"
        style={{ scrollbarWidth: "none" }}
      >
        <div className="flex flex-col items-start gap-2 px-4">
          {/* Dashboard */}
          <span
            className={`text-[14px] font-[500] ${
              location.pathname === "/Brand/DashBoard" ||
              location.pathname === "/Brand/"
                ? "text-[#FAFAFA] bg-[#4b4b4b]"
                : "text-[#424242] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            onClick={() => {
              mixpanel.track("Sidebar: Dashboard - clicked");
              navigate("/Brand/DashBoard");
            }}
          >
            <LayoutDashboard size={24} /> Dashboard
          </span>
          {/* All campaigns */}
          <span
            className={`text-[14px] font-[500] ${
              location.pathname === "/Brand/DashBoard/AllCampaign" ||
              location.pathname === "/Brand/"
                ? "text-[#FAFAFA] bg-[#4b4b4b]"
                : "text-[#424242] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            onClick={() => {
              mixpanel.track("Sidebar: AllCampaign - clicked");
              navigate("/Brand/DashBoard/AllCampaign");
            }}
          >
            <Plus size={24} /> All Campaigns
          </span>

          {/* ----- Discover Creator ---------- */}
          {/* <span
            className={`text-[14px] font-[500] ${
              location.pathname.includes("/Brand/DashBoard/Discover")
                ? "text-[#FAFAFA] bg-[#4b4b4b]"
                : "text-[#424242] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            onClick={() => {
              mixpanel.track("Sidebar: Discover Creator - clicked");
              navigate("/Brand/DashBoard/Discover");
            }}
          >
            <PiCompass size={24} /> Discover Creator
          </span> */}

          {/* ----------- Payment History ----------- */}
          <span
            className={`text-[14px] font-[500] ${
              location.pathname.includes("/Brand/DashBoard/PaymentHistory")
                ? "text-[#FAFAFA] bg-[#4b4b4b]"
                : "text-[#424242] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            onClick={() => {
              mixpanel.track("Sidebar: Payment History - clicked");
              navigate("/Brand/DashBoard/PaymentHistory");
            }}
          >
            <PiArrowsLeftRight size={24} /> Payment History
          </span>

          {/* ----- feedback ---------- */}
          {/* <span
            className={`text-[14px] font-[500] ${
              location.pathname.includes("/Brand/DashBoard/Feedback")
                ? "text-[#FAFAFA] bg-[#4b4b4b]"
                : "text-[#424242] bg-transparent"
            }  w-full py-[6px] px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
            onClick={() => {
              mixpanel.track("Sidebar: Feedback - clicked");
              navigate("/Brand/DashBoard/Feedback");
            }}
          >
            <VscFeedback size={24} /> Feedback
          </span> */}
        </div>
      </section>

      {/* ----------- profile section ------------- */}
      <Popover>
        <PopoverTrigger asChild>
          <section>
            <div className="flex items-center gap-2 border rounded-[5px] border-solid border-[#EEE] p-2 cursor-pointer">
              <img
                src={currentProfile}
                alt="logo"
                className="w-10 h-10 rounded-full"
              />

              <section className="flex flex-col gap-1">
                <span className="text-[16px] font-bold text-[#424242]">
                  {(brand && brand?.data1 && brand?.data1?.CompanyName) ||
                    "No Brand Name"}
                </span>
                <p className="text-[#121212] text-xs not-italic font-medium leading-[normal]">
                  {authState?.loggedBrand?.credits} Credits Earned!
                </p>
              </section>
              <ChevronsUpDown
                size={24}
                color="#BEBDBD"
                className="ml-2 shrink-0 opacity-50"
              />
            </div>
          </section>
        </PopoverTrigger>
        <PopoverContent className="w-auto">
          <div className="flex flex-col gap-2 items-start ">
            {/* <span
              className={`text-[14px] font-[500] ${
                location.pathname === "/Brand/DashBoard/UnlockedInfluencer"
                  ? "text-[#FAFAFA] bg-[#4b4b4b]"
                  : "text-[#424242] bg-transparent"
              } w-full py-[6px] relative px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
              onClick={() => {
                mixpanel.track("Sidebar: Unlocked Creators - clicked");
                navigate("/Brand/DashBoard/UnlockedInfluencer");
              }}
            >
              <UnlockProfileSvg
                fill={
                  location.pathname === "/Brand/DashBoard/UnlockedInfluencer"
                    ? "#FAFAFA"
                    : ""
                }
              />{" "}
              Unlocked Creators
            </span> */}

            <span
              className={`text-[14px] font-[500] ${
                location.pathname === "/Brand/DashBoard/CreditsHistory"
                  ? "text-[#FAFAFA] bg-[#4b4b4b]"
                  : "text-[#424242] bg-transparent"
              } w-full py-[6px] px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
              onClick={() => {
                mixpanel.track("Sidebar: Credits History - clicked");
                navigate("/Brand/DashBoard/CreditsHistory");
              }}
            >
              <PiSquaresFourBold size={24} /> Credits History
            </span>

            {/* <span
              className={`text-[14px] font-[500] ${
                location.pathname === "/Brand/DashBoard/UnlockInfluencerSearch"
                  ? "text-[#FAFAFA] bg-[#4b4b4b]"
                  : "text-[#424242] bg-transparent"
              } w-full py-[6px] relative px-3 hover:bg-[#4b4b4b] hover:text-[#FAFAFA] rounded-md cursor-pointer flex items-center gap-2`}
              onClick={() => {
                mixpanel.track("Sidebar: Unlock Creators - clicked");
                navigate("/Brand/DashBoard/UnlockInfluencerSearch");
              }}
            >
              <CgProfile size={24} /> Unlock Creators
            </span> */}
            <span
              className={`text-[14px] font-[500] ${
                location.pathname === "/Brand/pricing"
                  ? "text-[#FAFAFA] bg-[#4b4b4b]"
                  : "text-[#424242] bg-transparent"
              } w-full py-[6px] relative px-3  hover:text-[#EF4444] rounded-md cursor-pointer flex items-center gap-2`}
              onClick={() => {
                mixpanel.track("Sidebar:pricing - clicked");
                navigate("/Brand/pricing");
              }}
            >
              Pricing
            </span>
            <span
              className={`text-[14px] font-[500] ${
                location.pathname === "/Brand/logout"
                  ? "text-[#FAFAFA] bg-[#4b4b4b]"
                  : "text-[#424242] bg-transparent"
              } w-full py-[6px] relative px-3  hover:text-[#EF4444] rounded-md cursor-pointer flex items-center gap-2`}
              onClick={() => {
                mixpanel.track("Sidebar:logout - clicked");
                navigate("/logout");
              }}
            >
              LogOut
            </span>
          </div>
        </PopoverContent>
      </Popover>
    </aside>
  );
};

export default Sidebar;
